import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/Layout.vue'
import store from '@/store/index'

// 模块路由
import dashboard from '@/router/module/dashboard'
import orders from '@/router/module/orders'
import afterSale from '@/router/module/afterSale'
import supply from '@/router/module/supply'
import user from '@/router/module/user'
import download from '@/router/module/download'
import report from '@/router/module/report'
import service from '@/router/module/service'
import finance from '@/router/module/finance'
import operation from '@/router/module/operation'
import customer from '@/router/module/customer'
import statistics from '@/router/module/statistics'
import seo from '@/router/module/seo'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: '登录',
    component: () => import('@/views/login/Index.vue')
  },

  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue')
  },

  dashboard,
  orders,
  afterSale,
  supply,
  user,
  download,
  report,
  service,
  finance,
  operation,
  statistics,
  customer,
  seo,

  {
    path: '/test',
    component: Layout,
    children: [
      {
        path: '',
        name: '测试页面',
        component: () => import('@/views/common/Test.vue')
      }
    ]
  },

  { path: '*', redirect: '/404' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes
})

// 页面跳转不添加tab的路由
const NOT_ADD_TAB_PATH = [
  '/login',
]

// 不缓存query的路由
const NOT_CACHE_QUERY_PATH = [
]

router.beforeEach((to, from, next) => {
  if (!NOT_ADD_TAB_PATH.includes(to.path)) {
    store.commit('user/addTab', {
      name: to.name,
      path: to.path,
      key: to.path,
      pageName: to.meta.pageName,
      query: NOT_CACHE_QUERY_PATH.includes(to.path) ? {} : to.query
    })
  }
  next()
})

export default router
